export const getDDLoptionText = (value, options) => {
   const filteredData = options.filter((o) => o.value === value);
   const found = filteredData.length > 0;

   return found ? filteredData[0].text : null;
};
